/**
 * Program brand color: optional #RRGGBB stored on Program.
 * Same parse/normalize contract as server/utils/programColor.js.
 */

export const PROGRAM_COLOR_FORMAT_ERROR = "Color must be #RRGGBB (e.g. #4f46e5)";

/** Native color input cannot be empty; preview only — not persisted until the user picks. */
export const PROGRAM_COLOR_PICKER_FALLBACK = "#4f46e5";

/** Events with no program on Registration Metrics By program. */
export const NO_PROGRAM_CHART_COLOR = "#9ca3af";

/** Same indigo palette Registration Metrics used when a program has no stored color. */
export const PROGRAM_CHART_FALLBACK_PALETTE = [
  "#312e81",
  "#4f46e5",
  "#6366f1",
  "#818cf8",
  "#a5b4fc",
  "#c7d2fe",
  "#4c1d95",
  "#5b21b6",
];

const HEX6 = /^#?([0-9A-Fa-f]{6})$/;

/**
 * Optional program color. Empty is valid (no staff color yet).
 * Accepts `#RRGGBB` or `RRGGBB`; normalizes to lowercase `#rrggbb`.
 * @param {unknown} value
 * @returns {{ ok: true, color: string } | { ok: false, error: string }}
 */
export function parseProgramColor(value) {
  if (value == null) return { ok: true, color: "" };
  const t = String(value).trim();
  if (!t) return { ok: true, color: "" };
  const m = t.match(HEX6);
  if (!m) return { ok: false, error: PROGRAM_COLOR_FORMAT_ERROR };
  return { ok: true, color: `#${m[1].toLowerCase()}` };
}

/**
 * Chart segment/legend color for a program group.
 * @param {{ groupKey?: string, storedColor?: unknown, fallbackIndex?: number }} params
 * @returns {string}
 */
export function resolveProgramChartColor({ groupKey, storedColor, fallbackIndex = 0 } = {}) {
  const key = groupKey != null ? String(groupKey).trim() : "";
  if (!key || key === "__none__") return NO_PROGRAM_CHART_COLOR;
  const parsed = parseProgramColor(storedColor);
  if (parsed.ok && parsed.color) return parsed.color;
  const idx = Number.isInteger(fallbackIndex) && fallbackIndex >= 0 ? fallbackIndex : 0;
  return PROGRAM_CHART_FALLBACK_PALETTE[idx % PROGRAM_CHART_FALLBACK_PALETTE.length];
}
